import { useConversationData } from '~/composables/main';
import { useConversationActiveId } from '~/composables/main';
import { useServiceData } from '~/composables/main';
import { useIsDuringAIMessage } from '~/composables/main';
import {
  ModelConversationDetailMessage,
  ModelConversationDetailProcess,
  ModelPOSTConversationAssociationConversationFile,
  ModelSource,
} from '~/services/conversation/dto/conversation.detail.dto';
import { convertMarkdownToHtml } from './display';
import { detectJSONStart } from './data';

export async function streamConversationSSE(
  dataList: AsyncIterable<any>,
  mode: 'initial' | 'append' = 'initial',
  message?: string,
  filesList: any[] = []
) {
  const { $functions } = useNuxtApp();
  const gConversationData = useConversationData();
  const gServiceData = useServiceData();
  const gConversationActiveId = useConversationActiveId();
  const gIsDuringAIMessage = useIsDuringAIMessage();

  let fullResponse = '';
  let contentStarted = false;
  let content = '';
  let isJsonFormatList = []

  try {
    let index = 0;
    for await (const data of dataList) {
      // console.log('SSE streamConversationSSE data', data);
      switch (data.eventType) {
        case 'message-agent':
        case 'message-output':
          break;
        case 'message-start':
        case 'message-end':
        case 'message-stream':
          gConversationData.value.conversationMessageList =
            gConversationData.value.conversationMessageList.map((e) => {
              if (e.id === data.conversationId) {
                if (data.value.text) {
                  fullResponse += data.value.text;
                  isJsonFormatList.push(detectJSONStart(data.value.text).isJsonFormat);
                  if(isJsonFormatList.some(e => e)) {
                    if (
                      !contentStarted &&
                      fullResponse.includes('"content":')
                    ) {
                      contentStarted = true;
                    }
                    if (contentStarted) {
                      const match = fullResponse.match(
                        /"content"\s*:\s*"((?:[^"\\]|\\.)*)"/
                      );
                      if (match) {
                        const newContent = match[1];
                        const delta = newContent.slice(content.length); 
                        if (delta) {
                          e.aiMessage = convertMarkdownToHtml(
                            `${e.aiMessage || ''}${delta}`
                          );
                          e.aiMessageList.push(delta);
                        }
                        content = newContent;
                      }
                    } 
                  }else {
                    e.aiMessage = convertMarkdownToHtml(
                      `${e.aiMessage || ''}${data.value.text}`
                    );
                    e.aiMessageList.push(data.value.text);
                  }
                  e.isNewAIMessage = true;
                }
                if (data.value?.sources) {
                  e.sourceList = (data.value?.sources || []).map(
                    (s: any) => new ModelSource(s)
                  );
                }
                if (data.value?.isGenerateImage) {
                  e.isGenerateImage = true;
                  e.isNewAIMessage = false;
                }
                if (data.eventType === 'message-end') {
                  e.aiMessage = convertMarkdownToHtml(e.aiMessage || '', {
                    isEndStream: true,
                  });
                  e.isEndStream = true;
                  e.generatedImagesList = (data.value?.genImage || []).map(
                    (img: any) =>
                      new ModelPOSTConversationAssociationConversationFile(img)
                  );
                  e.isMaxToken = data.value.isMaxToken || false;
                  e.updatedAt = e.updatedAt || new Date();
                  e.createdAt = e.createdAt || new Date();
                  e.displayCreatedAt =  e.displayCreatedAt || $functions.displayDate(e.createdAt, { isOnlyTime: true });
                  e.displayUpdatedAt = e.displayUpdatedAt || $functions.displayDate(e.updatedAt, { isOnlyTime: true });
                }
              } else {
                e.isNewAIMessage = false;
              }
              return e;
            });

          if (data.eventType === 'message-end') {
            // setTimeout(() => {
            //   Prism.highlightAll();
            // }, 100);
            gIsDuringAIMessage.value = false;
          }
          break;
        case 'title':
          gConversationActiveId.value = gConversationData.value.id;
          // await gServiceData.value.getConversarion()
          break;
        case 'message-event':
          gConversationData.value.conversationMessageList =
            gConversationData.value.conversationMessageList.map((e) => {
              if (e.id === data.conversationId) {
                let isReplace = false;
                e.processList = e.processList.map(
                  (ep: ModelConversationDetailProcess) => {
                    if (
                      (ep.title || '').toLowerCase() ===
                        (data.value.title || '').toLowerCase() &&
                      e.processPreviousTitle === data.value.title
                    ) {
                      ep = data.value;
                      isReplace = true;
                    }
                    return ep;
                  }
                );
                if (!isReplace) {
                  e.processList.push(data.value);
                }

                e.processPreviousTitle = data.value.title;
                e.processHeader = data.value.title;
              }

              if (data.value.title === 'Generating image') {
                e.isGenerateImage = true;
              }

              return e;
            });
          break;
      }
    }
    console.log(
      'SSE streamConversationSSE end',
      gConversationData.value.conversationMessageList
    );
  } catch (err) {
    console.error('SSE initialConversation error', err);
  }
}
